import { loadEventOnDecoders } from './load-event-on-decoders';

export const actions = { loadEventOnDecoders };
